import Box from '@mui/material/Box';
import { makeStyles } from '@material-ui/core/styles';
import Pagination, { PaginationRenderItemParams } from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import { useEffect, useState } from 'react';
import styles from './styles.module.css';

type PaginationWithMoreAtLastProps = {
  totalPage: number;
  curPage: number;
  handleChange: (eventHanler: object, page: number) => void;
  gap?: number;
};

const MAX_RANGE_PAGINATION_CAN_SHOW = 4;
const useStyles = makeStyles(() => ({
  root: {
    '& .MuiPaginationItem-root': {
      border: '1px solid #DFE3E8',
      color: '#333',
      fontFamily: 'Inter, sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      height: '32px',
    },
    '& .Mui-selected': {
      border: '1px solid var(--primary-color)',
      color: 'var(--primary-color)',
      fontWeight: '700',
    },
    '& .Mui-disabled': {
      opacity: '1',
      color: '#C4CDD5',
    },
  },
}));

const PaginationWithMoreAtLast = ({ totalPage = 1, curPage = 1, handleChange, gap = 0 }: PaginationWithMoreAtLastProps) => {
  const classes = useStyles();
  const [current, setCurrent] = useState<number>(curPage || 1);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    if (value !== current) {
      handleChange(event, value);
    }
  };

  // Hide last Page Item if Items appear "..." page
  const renderPaginationItem = (item: PaginationRenderItemParams) => {
    const currentPageInRangePaginationShow = totalPage - current < MAX_RANGE_PAGINATION_CAN_SHOW;

    const isLastPage = item.page === totalPage;
    if (isLastPage) {
      if (currentPageInRangePaginationShow) return <PaginationItem {...item} />;
      return null;
    }

    return <PaginationItem {...item} />;
  };

  useEffect(() => {
    setCurrent(curPage || 1);
  }, [curPage]);

  return (
    <Box className={styles.pagiContainer} gap={gap}>
      <Pagination className={classes.root} count={totalPage} page={current} onChange={handlePageChange} renderItem={renderPaginationItem} />
    </Box>
  );
};

export default PaginationWithMoreAtLast;
